import _classCallCheck from "/home/gonzalo/wfdev/webfarming-app-client/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/gonzalo/wfdev/webfarming-app-client/node_modules/@babel/runtime/helpers/esm/createClass";
import DoubleBits from './DoubleBits';
var IntervalSize = /*#__PURE__*/function () {
  function IntervalSize() {
    _classCallCheck(this, IntervalSize);
  }
  _createClass(IntervalSize, null, [{
    key: "isZeroWidth",
    value: function isZeroWidth(min, max) {
      var width = max - min;
      if (width === 0.0) return true;
      var maxAbs = Math.max(Math.abs(min), Math.abs(max));
      var scaledInterval = width / maxAbs;
      var level = DoubleBits.exponent(scaledInterval);
      return level <= IntervalSize.MIN_BINARY_EXPONENT;
    }
  }]);
  return IntervalSize;
}();
export { IntervalSize as default };
IntervalSize.MIN_BINARY_EXPONENT = -50;